import React from 'react'
import { MultiStateCheckbox } from 'primereact/multistatecheckbox'

const MultiStateCheckboxInput = (props: {
    value: string
    onChangeCallback: (input?: any) => void
    name?: string
    label?: string | Element
    options?: any
}) => {
    const { value, onChangeCallback, name, label, options } = props
    const id = name + '_cb_id'

    return (
        <div className="col-12 wardrobe-checkbox">
            <MultiStateCheckbox
                // id={id}
                inputId={id}
                value={value}
                options={options}
                optionValue="value"
                onChange={(e) => {
                    onChangeCallback(e)
                }}
            />
            <label htmlFor={id} className="p-checkbox-label p-mb-0 p-ml-2">
                {label}
            </label>
        </div>
    )
}

export default MultiStateCheckboxInput
